import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { useGlobalContext } from '../../contexts/GlobalContext';
import RoutesApp from '../../routes';

//Servicios
import { UserService } from '../../services/api';

//Componentes
import Spinner from '../../components/spinner/Spinner';
import UserINAVI from './UserINAVI';

function UserINAVIContainer() {
    const { toast, token, buildBooleanOptions, buildSelectOptions } =
        useGlobalContext();
    const formMethods = useForm();

    const [loader, setLoader] = useState(false);

    const Params = useParams();
    const Navigate = useNavigate();

    const password = useRef({});
    password.current = formMethods.watch('clave');

    // useEffect(() => {
    //     async function fetchUserINAVI() {
    //         try {
    //             setLoader(true);

    //             const UserINAVI = await UserService.single({
    //                 token,
    //                 usuarioId: Params.id,
    //             });

    //             if (UserINAVI) {
    //                 UserINAVI.data.clave = '';
    //                 formMethods.reset(UserINAVI.data);
    //             }

    //             setLoader(false);
    //         } catch (err) {
    //             setLoader(false);
    //             return err;
    //         }
    //     }

    //     fetchUserINAVI();
    // }, [Params.id]);

    const onSubmit = async (data) => {
        // console.log(data);
        try {
            setLoader(true);

            delete data.confirmPassword;

            //Creamos o actualizamos el Encargado
            const UserINAVI = await UserService.createINAVI({
                token,
                usuario: data,
            });

            if (UserINAVI) {
                Navigate(RoutesApp.Users.all);
                toast('Usuario INAVI creado con éxito', { type: 'success' });
            }

            setLoader(false);
        } catch (err) {
            setLoader(false);
            toast('No se pudo crear el usuario INAVI', { type: 'error' });
            return err;
        }
    };

    return loader ? (
        <Spinner />
    ) : (
        <UserINAVI
            states={{ password }}
            functions={{
                ...formMethods,
                onSubmit,
                buildBooleanOptions,
                buildSelectOptions,
            }}
        />
    );
}

export default UserINAVIContainer;
